function initCsAddButtons(){

  const cs_checkoutBtn = document.querySelectorAll(".cs_button");
  const cs__addtocart = document.querySelectorAll('.cs__addtocart');
  const cs_modal = document.getElementById("cs_modal");
  const cs_closeModal = document.getElementById("cs_close-modal");
  const cs_confirmBtn = document.getElementById("cs_confirm-selection");
  const cs_btnText = document.getElementById("cs_btn-text");
  const cs_spinner = document.getElementById("cs_spinner");
  const cs_options = document.querySelectorAll(".cs_product-option");
  const headersticky = document.querySelector('.section-header');
  const cartNoti = document.querySelector('.cart-notification');
  const cs_add = document.querySelectorAll('.cs_add');
   const cs_targetId = cs_modal.dataset.target;
  
  cs_add?.forEach(btn => {
  btn.addEventListener("click", async function (e) {
    e.preventDefault();

    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add("cs_disabled");
    const originalText = btn.textContent;
    btn.textContent = "Adding...";

    try {
      // Build FormData like Dawn's product form
      const formData = new FormData();
      formData.append("id", Number(cs_targetId));
      formData.append("quantity", 1);

      // Ask Shopify to render these sections (Dawn uses these keys)
      const sections = [
        "cart-notification-product",
        "cart-notification-button",
        "cart-icon-bubble"
      ];
      formData.append("sections", sections.join(","));
      formData.append("sections_url", window.location.pathname);

      const addUrl =
        (window.routes && window.routes.cart_add_url) ||
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root + "cart/add") ||
        "/cart/add";

      const res = await fetch(addUrl, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Accept": "application/json" // Dawn uses response.json()
        },
        body: formData
      });

      const response = await res.json();

      // Dawn-style error handling
      if (response.status) {
        // You can publish an event or show the message like Dawn does
        console.error("Cart add error:", response);
        alert(response.message || response.description || "Unable to add item to cart.");
        return;
      }

      // Find cart-notification (Dawn's CartNotification instance)
      const cartNotification = document.querySelector("cart-notification");
      // If this script is used in a quick-add modal context, mimic Dawn's behavior:
      const quickAddModal = btn.closest && btn.closest("quick-add-modal");

      if (quickAddModal) {
        // Wait for modal to close, then render contents (same pattern Dawn uses)
        document.body.addEventListener(
          "modalClosed",
          () => {
            setTimeout(() => {
              if (cartNotification && typeof cartNotification.renderContents === "function") {
                cartNotification.renderContents(response);
              }
            }, 0);
          },
          { once: true }
        );
        // Hide the quick add modal (Dawn uses quickAddModal.hide(true))
        if (typeof quickAddModal.hide === "function") quickAddModal.hide(true);
      } else {
        // Normal path: just render the returned sections into the notification
        if (cartNotification && typeof cartNotification.renderContents === "function") {
          cartNotification.renderContents(response);
        } else {
          // fallback: if notification not found, redirect to cart page
          window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : "/cart";
        }
      }
    } catch (err) {
      console.error("Add to cart error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      btn.disabled = false;
      btn.classList.remove("cs_disabled");
      btn.textContent = originalText;
    }
  });
});




 
  console.log("DOM Content Loaded.");
  console.log("Target Product ID:", cs_targetId);

  
  cs_options.forEach(opt => {
    opt.addEventListener("click", () => {
      console.log("Product option clicked:", opt.dataset.productId);
      cs_options.forEach(o => o.classList.remove("cs_selected"));
      opt.classList.add("cs_selected");
      opt.querySelector("input").checked = true;
      console.log("Selected product option:", opt.querySelector("input").value);
    });
  });

  function cs_openModal() {
    cs_modal.classList.remove("cs_hidden");
    document.body.style.overflow = "hidden";
    console.log("Modal opened.");
    headersticky.classList.remove("shopify-section-header-sticky");
    if (cartNoti.classList.contains("active")){
        cartNoti.classList.remove("active");
    }
  }

  function cs_closeModalFn() {
    cs_modal.classList.add("cs_hidden");
    document.body.style.overflow = ""; 
    console.log("Modal closed.");
      headersticky.classList.add("shopify-section-header-sticky");
  }

  cs_closeModal.addEventListener("click", cs_closeModalFn);
  console.log("Close modal event listener attached.");

  async function cs_targetExistsInCart() {
    console.log("Checking if target product exists in cart...");
    const cart = await fetch("/cart.js").then(res => res.json());
    console.log("Current cart:", cart);
    const exists = cart.items.some(item => item.id == cs_targetId);
    console.log("Target product in cart:", exists);
    return exists;
  }

  cs_confirmBtn.addEventListener("click", async () => {
    console.log("Confirm button clicked.");
    const cs_selected = document.querySelector('input[name="cs_selected_product"]:checked');
    if (!cs_selected) {
      console.log("No product selected, doing nothing.");
      return; // do nothing if none selected
    }

    const cs_newProductId = cs_selected.value;
    console.log("New product ID selected for addition:", cs_newProductId);

    try {
      cs_btnText.textContent = "Updating...";
      cs_spinner.classList.remove("cs_hidden");
      cs_confirmBtn.disabled = true;
      console.log("Updating UI for confirmation.");

      // 1️⃣ Get current cart
      console.log("Fetching current cart for update...");
      const cs_cart = await fetch("/cart.js").then(res => res.json());
      console.log("Cart before update:", cs_cart);

      // 2️⃣ Remove target product if present
      const cs_item = cs_cart.items.find(i => i.id == cs_targetId);
      console.log("cs_item",cs_item);
      const retainedQTY = cs_item.quantity || 1;
      if (cs_item) {
        console.log("Target product found in cart, removing:", cs_item.key);
        await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: { [cs_item.key]: 0 } })
        });
        console.log("Target product removal request sent.");
      } else {
        console.log("Target product not found in cart, no removal needed.");
      }

      // 3️⃣ Add selected product
      console.log("Adding new product to cart:", cs_newProductId);
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: cs_newProductId, quantity: retainedQTY }] })
      });
      console.log("New product addition request sent.");

      // 4️⃣ Redirect to checkout
      console.log("Redirecting to checkout...");
      window.location.href = "/checkout";
    } catch (err) {
      console.error("CS Add/Remove error:", err);
    } finally {
      cs_btnText.textContent = "Continue to Checkout";
      cs_spinner.classList.add("cs_hidden");
      cs_confirmBtn.disabled = false;
      cs_closeModalFn();
      console.log("UI restored after confirmation.");
    }
  });
  console.log("Confirm button event listener attached.");

  // Open modal only if target product exists in cart
  cs_checkoutBtn?.forEach(btn=>{
    btn.addEventListener("click", async (e) => {
    e.preventDefault();
    console.log("Checkout button clicked. (Function runs)");

    const targetExists = await cs_targetExistsInCart();

    if (targetExists) {
      console.log("Target product exists in cart, opening modal.");
      cs_openModal();
    } else {
      console.log("Target product not in cart, proceeding directly to checkout.");
      // Target product not in cart, proceed normally
      window.location.href = "/checkout";
    }
  });
  });
    cs__addtocart?.forEach(btn=>{
    btn.addEventListener("click", async (e) => {
    e.preventDefault();
    console.log("Checkout button clicked. (Function runs)");

    const targetExists = await cs_targetExistsInCart();

    if (targetExists) {
      console.log("Target product exists in cart, opening modal.");
      cs_openModal();
    } else {
      console.log("Target product not in cart, proceeding directly to checkout.");
      // Target product not in cart, proceed normally
      window.location.href = "/cart";
    }
  });
  });
  console.log("Checkout button event listener attached.");
}
document.addEventListener("DOMContentLoaded", initCsAddButtons);
document.addEventListener("shopify:section:load", initCsAddButtons);